// Gestión del tema claro/oscuro. Persiste en localStorage y aplica la clase
// `dark` en <html>. initTheme() se llama antes del render para evitar parpadeo.
import { useEffect, useState } from "react";

export type Theme = "light" | "dark";
const KEY = "tiger.theme";

export function getTheme(): Theme {
  const saved = localStorage.getItem(KEY);
  if (saved === "dark" || saved === "light") return saved;
  return "light"; // claro por defecto; el usuario elige oscuro con el icono de la barra
}

export function applyTheme(t: Theme): void {
  document.documentElement.classList.toggle("dark", t === "dark");
}

export function initTheme(): void {
  applyTheme(getTheme());
}

/** Hook para el toggle: devuelve [theme, toggle] con transición suave. */
export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(() => getTheme());
  useEffect(() => { applyTheme(theme); }, [theme]);
  const toggle = (): void => {
    const root = document.documentElement;
    root.classList.add("theme-anim");
    window.setTimeout(() => root.classList.remove("theme-anim"), 320);
    setTheme((t) => {
      const next = t === "dark" ? "light" : "dark";
      localStorage.setItem(KEY, next);
      return next;
    });
  };
  return [theme, toggle];
}
